<template>
  <div class="box w2">
    <BaseModal id="new-shipment" v-model="showNewShipmentModal">
      <template v-slot:header> New shipment - {{ orderNumber }} </template>
      <div class="w-full pt-4 p-4">
        <div v-show="!creatingShipment">
          <form @submit.prevent="createShipment()">
            <label for="date">Date</label>
            <input
              id="date"
              type="date"
              v-model="newShipment.dateShipped"
              class="regular full bordered mb-2"
            />
            <label for="carrier">Carrier</label>
            <input
              id="carrier"
              v-model="newShipment.carrier"
              class="regular full bordered mb-2"
            />
            <label for="tracking-number">Tracking number</label>
            <input
              id="tracking-number"
              v-model="newShipment.tracking"
              class="regular full bordered mb-2"
            />
            <label for="shipping-service">Shipping service</label>
            <input
              id="shipping-service"
              v-model="newShipment.shippingService"
              class="regular full bordered mb-2"
            />
            <div id="response" class="hidden"></div>
            <button class="btn-success-button mx-auto" type="submit">
              Add
            </button>
          </form>
        </div>
        <BaseLoading :loading="creatingShipment"></BaseLoading>
      </div>
    </BaseModal>
    <div class="box-header">
      Shipments
    </div>
    <div class="content">
      <div v-if="shipments.length > 0" class="table-scroll">
        <table class="default-table">
          <thead>
            <tr>
              <th>Date shipped</th>
              <th>Carrier</th>
              <th>Service</th>
              <th>Tracking</th>
              <th>Cost</th>
              <th style="width: 60px"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="shipment in shipments" :key="shipment.id">
              <td class="whitespace-nowrap">
                {{ shipment.dateShipped || "—" }}
              </td>
              <td>
                {{ shipment.carrier }}
              </td>
              <td>
                {{ shipment.shippingService }}
              </td>
              <td>
                <span class="tracking">{{ shipment.tracking }}</span>
              </td>
              <td class="whitespace-nowrap">
                {{ shipment.labelCost | currencyFormatted(true) }}
                <div v-if="shipment.insuranceCost > 0" class="cost-extra">
                  Insurance
                  {{ shipment.insuranceCost | currencyFormatted(true) }}
                </div>
              </td>
              <td>
                <button
                  type="button"
                  class="row-delete"
                  title="Delete shipment"
                  @click="deleteShipment(shipment.id)"
                >
                  <i class="mdi mdi-delete-outline"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="shipments.length === 0" class="empty-state">
        <i class="mdi mdi-truck-outline"></i>
        <p>This order does not have any shipment.</p>
      </div>
      <div class="form-actions">
        <button type="button" class="add-btn" @click="startCreateShipment()">
          <i class="mdi mdi-plus"></i>
          Add shipment
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  createShipmentService,
  deleteShipmentService
} from "@/api/store/OrdersService.js";
export default {
  props: {
    shipments: {
      type: Array,
      required: true
    },
    orderNumber: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showNewShipmentModal: false,
      newShipment: {
        carrier: "",
        tracking: "",
        shippingService: ""
      },
      creatingShipment: false
    };
  },
  methods: {
    startCreateShipment() {
      const responseBox = document.getElementById("response");
      responseBox.classList.add("hidden");
      this.showNewShipmentModal = true;
    },
    deleteShipment(id) {
      if (confirm("Are you sure you want to delete this shipment?")) {
        deleteShipmentService(id)
          .then(() => {
            this.$emit("deletedShipment", id);
            this.$toast.open({
              message: `Shipment deleted`,
              type: "success",
              position: "top-right"
            });
          })
          .catch(err => {
            this.$toast.open({
              message: `${err.response.data ?? err.message}`,
              type: "error",
              position: "top-right"
            });
          });
      }
    },
    createShipment() {
      const responseBox = document.getElementById("response");
      responseBox.classList.add("hidden");
      if (
        this.newShipment.carrier == "" ||
        this.newShipment.tracking == "" ||
        this.newShipment.shippingService == ""
      ) {
        responseBox.innerHTML = "error";
        responseBox.classList.remove("hidden");
        return;
      }
      this.creatingShipment = true;
      createShipmentService(this.orderNumber, this.newShipment)
        .then(id => {
          responseBox.innerHTML = "Ok";
          responseBox.classList.remove("hidden");
          this.creatingShipment = false;
          this.newShipment.id = id;
          this.$emit("addedShipment", this.newShipment);
          this.showNewShipmentModal = false;
          this.newShipment = {
            carrier: "",
            tracking: "",
            shippingService: ""
          };
        })
        .catch(() => {
          this.creatingShipment = false;
          responseBox.innerHTML = "API Error";
          responseBox.classList.remove("hidden");
        });
    }
  }
};
</script>
<style lang="scss">
#new-shipment {
  .modal-content {
    max-width: 350px;
    height: auto;
  }
}
</style>
<style lang="scss" scoped>
.table-scroll {
  overflow-x: auto;
}

.tracking {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 16px;
  overflow-wrap: anywhere;
}

.cost-extra {
  font-size: 16px;
  color: #6b7280;
}

.row-delete {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  color: #9ca3af;

  i {
    font-size: 18px;
  }

  &:hover {
    background: #fef2f2;
    color: #dc2626;
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 1.5rem 1rem;
  color: #6b7280;

  i {
    font-size: 2.25rem;
    color: #d1d5db;
  }

  p {
    margin: 0;
    font-size: 16px;
  }
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}

.add-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 36px;
  padding: 0 14px;
  border: 1px solid #126e6a;
  border-radius: 8px;
  background: #126e6a;
  font-size: 16px;
  font-weight: 500;
  color: white;

  i {
    font-size: 18px;
  }

  &:hover {
    filter: brightness(1.1);
  }
}
</style>
